// @flow
import ActionTypes from './action-types';
import type { ProjectStatusAction } from './sagas';

export type ProjectStatusState = {
  data: {
    "actual_progress": number,
    "expected_completion_date": string,
    "overall_status": string,
    "planned_completion_date": string,
    "planned_progress": number,
    project_name: string,
  } | {},
  loading: boolean | null,
};

const initialState: ProjectStatusState = { loading: null, data: {} };

export default function (state: ProjectStatusState = initialState, action: ProjectStatusAction): ProjectStatusState {
  switch (action.type) {
    case ActionTypes.GET_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case ActionTypes.GET_PROJECT_STATUS_FAIL:
      return {
        ...state,
        data: {},
        loading: false,
      };
    default:
      return state;
  }
}
